import React, { useState } from "react"
import PropTypes from "prop-types"
import useSurveyResultsData from "../static_queries/useSurveyResultsData";
import ChartHandler from "./charts/chart-handler"
import CommunityInsight from "./community-insight";
import SocialShare from "./social-share";
import Icon from '@mdi/react';
import Img from "gatsby-image";
import { mdiChartArc, mdiChartLine, mdiChartBar, mdiMapMarker, mdiAccountGroup, mdiHeart, mdiHeartBroken, mdiDiamondStone, mdiChartTimelineVariant, mdiPodcast, mdiRss, mdiHammerWrench, mdiSchool, mdiAirplaneTakeoff, mdiBookOpenVariant } from '@mdi/js';

export default function SurveyResultList({resultRelativePath}) {
  const surveyResultsData = useSurveyResultsData()
  const [isSeeAllOpen, setIsSeeAllOpen] = useState(false)

  const surveyResultsIcons = {
    "mdiChartArc": mdiChartArc,
    "mdiChartLine": mdiChartLine,
    "mdiChartBar": mdiChartBar,
    "mdiMapMarker": mdiMapMarker,
    "mdiAccountGroup": mdiAccountGroup,
    "mdiHeart": mdiHeart,
    "mdiHeartBroken": mdiHeartBroken,
    "mdiDiamondStone": mdiDiamondStone,
    "mdiChartTimelineVariant": mdiChartTimelineVariant,
    "mdiPodcast": mdiPodcast,
    "mdiRss": mdiRss,
    "mdiHammerWrench": mdiHammerWrench,
    "mdiSchool": mdiSchool,
    "mdiAirplaneTakeoff": mdiAirplaneTakeoff,
    "mdiBookOpenVariant": mdiBookOpenVariant
  };

  function handleOther(tags, title = 'Other responses:') {
    return (
      <div className="other-responses my-6">
        <h4 className="title is-family-sans-serif is-5">{title}</h4>
        <div className="tags mt-4 is-family-sans-serif">
          {
            tags.map(tag => <span key={tag} className="tag">{tag}</span>)
          }
        </div>
      </div>
    )
  }

  function handleSeeAll() {
    if (!isSeeAllOpen) {
      setIsSeeAllOpen(true)
    } else {
      setIsSeeAllOpen(false)
    }
  }

  function listLink(item, i, resultIcon) {
    const isBlankUrl = !item.url;

    return (
      <div key={i} className="is-linkable-list-item">
          <a
            className={`is-family-sans-serif is-link py-1 px-1 mr-5 mb-3 ${isBlankUrl ? 'is-disabled-link' : ''}`}
            href={item.url}
            target="_blank"
            rel="noreferrer"
          >
          <div className="is-linkable-list-item-text">
            {resultIcon &&
              <Icon path={resultIcon}
                size={1}
                title=""
              />
            }
            <span className="has-text-weight-bold ml-2">{item.display_text}</span>
          </div>
          {item.tag ? <small className="mx-2 tag">{item.tag}</small> : null}
        </a>
      </div>
    )
  }

  function listImageLink(item, i) {
    const isBlankUrl = !item.url;
    console.log(item.display_text + ": " + item.url);

    return (
      <div key={i} className="is-linkable-list-top-ten-item py-1 px-1">
        <a
          className={`is-family-sans-serif is-link ${isBlankUrl ? 'is-disabled-link' : ''}`}
          href={item.url}
          target="_blank"
          rel="noreferrer"
          title={item.display_text}
        >
          {item.list_item_image ?
            <Img fluid={item.list_item_image.childImageSharp.fluid} alt={item.display_text} />
          : <span>{item.display_text}</span>
          }
          {item.tag ? <small className="tag">{item.tag}</small> : null}
        </a>
      </div>
    )
  }

  function handleRankedLinkableList(list_items, resultIcon = mdiDiamondStone) {
    if (list_items.length > 0) {
      return (
        <>
          { list_items.length > 0 && <h4 className="subtitle is-4 is-uppercase">Top 10</h4> }
            <div className="is-linkable-list-top-ten">
              {
                list_items.map((item, i) => {
                  if (i < 10){
                    if (item.list_item_image !== null) {
                      return listImageLink(item, i)
                    }
                    return listLink(item, i, resultIcon)
                  }
                })
              }
            </div>
            { list_items.length > 10 &&
              <>
              <h5 className="subtitle is-5 mt-5">Other mentions:</h5>
              <div className="is-linkable-list">
                {
                  list_items.map((item, i) => {
                    if (i >= 10 && i < 16){
                      return listLink(item, i, resultIcon)
                    }
                  }
                )}
              </div>
              {(!isSeeAllOpen && list_items.length > 16) &&
                <div className="level">
                <div className="level-left"></div>
                  <div className="level-right">
                    <button className="button is-small is-family-sans-serif is-uppercase level-item" onClick={handleSeeAll}>Show all</button>
                  </div>
                </div>
              }
              <div className="is-linkable-list">
                { isSeeAllOpen &&
                  list_items.map((item, i) => {
                    if (i >= 16 ){
                      return listLink(item, i, resultIcon)
                    }
                  }
                )}
            </div>
            </>
          }
        </>
      )
    }
  }

  function handleRankedLinkableListFive(list_items, resultIcon = mdiDiamondStone) {
    if (list_items.length > 0) {
      return (
        <>
          { list_items.length > 0 && <h4 className="subtitle is-4 is-uppercase">Top 5</h4> }
            <div className="is-linkable-list-top-ten">
              {
                list_items.map((item, i) => {
                  if (i < 5){
                    if (item.list_item_image !== null) {
                      return listImageLink(item, i)
                    }
                    return listLink(item, i, resultIcon)
                  }
                })
              }
            </div>
            { list_items.length > 5 &&
              <>
              <h5 className="subtitle is-5 mt-5">Other mentions:</h5>
              <div className="is-linkable-list">
                {
                  list_items.map((item, i) => {
                    if (i >= 5 && i < 11){
                      return listLink(item, i, resultIcon)
                    }
                  }
                )}
              </div>
            </>
          }
        </>
      )
    }
  }

  function renderSurveyResultsData() {
    return (
      <>
        {surveyResultsData.map(result => {
          if (resultRelativePath === result.node.relativePath) {
            const resultIcon = surveyResultsIcons[result.node.childMarkdownRemark.frontmatter.icon];
            const insightData = {
              name: result.node.childMarkdownRemark.frontmatter.insight_name,
              bio: result.node.childMarkdownRemark.frontmatter.insight_bio,
              quote: result.node.childMarkdownRemark.frontmatter.insight_quote,
              insight_image: result.node.childMarkdownRemark.frontmatter.insight_image,
            }
            const displayOtherTags = result.node.childMarkdownRemark.frontmatter.display_other
            const otherTags = result.node.childMarkdownRemark.frontmatter.other_tags || []
            const otherTagsTitle = result.node.childMarkdownRemark.frontmatter.other_tags_title || undefined

            return (
              <div key={result.node.id} id={result.node.name} className="is-survey-result pb-6 my-6">
                <div className="survey-result-eyebrow mb-2">
                  {resultIcon &&
                    <div className="survey-result-title-icon has-text-grey-dark">
                      <Icon path={resultIcon} size={1.7} title="Result" />
                    </div>
                  }
                  <SocialShare sectionId={result.node.name} sectionTitle={result.node.childMarkdownRemark.frontmatter.title}/>
                </div>
                <div className="survey-result-title-container py-2">
                  <h3 className="title">{result.node.childMarkdownRemark.frontmatter.title}</h3>
                </div>
                <div
                  className="content mt-5"
                  dangerouslySetInnerHTML={{ __html: result.node.childMarkdownRemark.html }}
                ></div>

                {result.node.childMarkdownRemark.frontmatter.graphic &&
                  <Img fluid={result.node.childMarkdownRemark.frontmatter.graphic.childImageSharp.fluid} />
                }

                {result.node.childMarkdownRemark.frontmatter.uses_nivo_chart == true &&
                  (
                    <ChartHandler
                      chart_type={result.node.childMarkdownRemark.frontmatter.chart_type}
                      data={result.node.childMarkdownRemark.frontmatter.data}
                      is_multiyear={result.node.childMarkdownRemark.frontmatter.is_multiyear}
                      crowdsignal_question_number={result.node.childMarkdownRemark.frontmatter.crowdsignal_question_number}
                      uses_legend={result.node.childMarkdownRemark.frontmatter.uses_legend}
                      custom_chart_height={result.node.childMarkdownRemark.frontmatter.custom_chart_height}
                    />
                  )
                }
                { displayOtherTags &&
                  handleOther(otherTags, otherTagsTitle)
                }
                { (result.node.childMarkdownRemark.frontmatter.ranked_linkable_list !== null && result.node.childMarkdownRemark.frontmatter.ranked_linkable_list.length == 11) &&
                  handleRankedLinkableListFive(result.node.childMarkdownRemark.frontmatter.ranked_linkable_list, resultIcon)
                }
                { (result.node.childMarkdownRemark.frontmatter.ranked_linkable_list !== null && result.node.childMarkdownRemark.frontmatter.ranked_linkable_list.length > 11) &&
                  handleRankedLinkableList(result.node.childMarkdownRemark.frontmatter.ranked_linkable_list, resultIcon)
                }
                { result.node.childMarkdownRemark.frontmatter.include_community_insight &&
                  <CommunityInsight insightData={insightData} />
                }
              </div>
            )
          } else { return null }
        })}
      </>
    )
  }
  return (
    <>
      {renderSurveyResultsData()}
    </>
  )
}

SurveyResultList.propTypes = {
  resultRelativePath: PropTypes.string,
}

SurveyResultList.defaultProps = {
  resultRelativePath: '',
}
